import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { PageSection } from '@app/core/components/PageSection';
import { publishMessages } from '@app/modules/social-export/publish';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useFragment } from '../../hooks/useFragment';
import { SocialExportPanorama, SocialExportPublishDropdown } from '../social-export-panorama';
import { useFragmentSocialUploadsQuery } from '../social-export-panorama/hooks/useFragmentSocialUploadsQuery';

/**
 * Social export section: permission-gated. Platform bar first, then uploads panorama.
 */
export function FragmentSocialPublishView() {
  const { fragment } = useFragment();
  const uploadsQuery = useFragmentSocialUploadsQuery(fragment.id);

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <QueryView query={uploadsQuery} inline>
        {() => {
          const publicationsCount = Array.from(uploadsQuery.data?.values() ?? []).flat().length;

          return (
            <Box>
              <PageSection message={publishMessages.publishToSectionTitle}>
                <SocialExportPublishDropdown />
              </PageSection>
              <PageSection
                message={publishMessages.publicationsSectionTitle}
                values={{ count: publicationsCount }}
              >
                <SocialExportPanorama uploadsByPlatform={uploadsQuery.data} />
              </PageSection>
            </Box>
          );
        }}
      </QueryView>
    </IfPermission>
  );
}
